import { createApp } from 'vue/dist/vue.esm-bundler.js'
import App from './App.vue'
import VueLazyload from '@jambonn/vue-lazyload'
import VueSocialSharing from 'vue-social-sharing'
import Toast from "vue-toastification";
import router from "./router"
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

createApp(App).use(router).use(VueLazyload).use(VueSocialSharing).use(Toast).mount('#app')

window.onbeforeunload = function() {
  return "Leaving this page will reset the wizard";
};
